import { FunctionComponent, useState, useEffect } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import gsap from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import Subscribe from '../Subscribe';
import AdvancedKit from './advancedKit';
import G1 from './../G1';
import css from './index.module.scss';
import SmartControlKit from './smartControlKit';
import StarterKit from './starterKit';
import StarterKit1 from './starterKit1';
import StarterKit2 from './starterKit2';
import FixedNav from './FixedNav';
import AppKit from './appKit';
import BuyKit from './buyKit';
import Delta2Kit from './delta2Kit';
import DeltaProKit from './deltaProKit';
import River2ProKit from './river2ProKit';
import { useCreateOptions, computedScrollTop } from './context';
import { useGlobal } from '@/utils/useGlobal';
import ScrollMagicFn from '@/utils/ScrollMagic';

const SolutionsDetail: FunctionComponent = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('landingPage');

    const { activeValue, setActiveValue, solutionInfo } = useCreateOptions(t, locale);

    const onFixedNavChange = (value: string) => {
        // 切换tab
        setActiveValue(value);
        // 切换tab时, 同时滚动到对应的内容模块
        gsap.to(document.documentElement, { duration: 1, scrollTo: { y: computedScrollTop(value) } });
    };

    // 动画
    let ScrollMagic: any;
    let controller: any;
    if (typeof window !== 'undefined') {
        ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }
    useEffect(() => {
        controller = new ScrollMagic.Controller();
        return () => {
            (ScrollMagic = null), (controller = null);
        };
    }, []);
    // 进入时 Tab Nav 触发性动画
    const [lookPosition, setLookPosition] = useState<boolean>(false);
    useEffect(() => {
        const scene = new ScrollMagic.Scene({ triggerElement: '#solutionsDetail', triggerHook: 'onLeave', offset: 0 });
        scene.on('enter', () => setLookPosition(true));
        scene.on('leave', () => setLookPosition(false));
        controller.addScene(scene);
    }, []);
    // 滚动选择 Tab 切换动画
    useEffect(() => {
        const addLeavePlaceholder = [...solutionInfo, { id: 'leave-placeholder' }];
        addLeavePlaceholder.forEach((item, index) => {
            const scene = new ScrollMagic.Scene({ triggerElement: `#${item.id}`, triggerHook: 'onEnter', offset: window.innerHeight / 2 });
            scene.on('enter', () => {
                setActiveValue(item.id);
            });
            scene.on('leave', () => {
                const preEnter = index - 1;
                if (preEnter >= 0) setActiveValue(addLeavePlaceholder[preEnter]['id']);
            });
            controller.addScene(scene);
        });
    }, []);

    return (
        <div className={css.solutionsDetail} id="solutionsDetail">
            <div className="content">
                <FixedNav options={solutionInfo} active={activeValue} onChange={onFixedNavChange} lookPosition={lookPosition} />
                {locale === 'us' && (
                    <>
                        <StarterKit id={solutionInfo[0]['id']} />
                        <StarterKit1 id={solutionInfo[1]['id']} />
                        <AdvancedKit id={solutionInfo[2]['id']} />
                        <SmartControlKit id={solutionInfo[3]?.id || solutionInfo[2]?.id} />
                    </>
                )}
                {['ca'].includes(locale) && (
                    <>
                        <StarterKit1 id={solutionInfo[0]['id']} />
                        <StarterKit2 id={solutionInfo[1]['id']} />
                        <StarterKit id={solutionInfo[2]['id']} />
                        <AdvancedKit id={solutionInfo[3]['id']} />
                    </>
                )}
                {['sa', 'za', 'au'].includes(locale) && (
                    <>
                        <River2ProKit id={solutionInfo[0]['id']} />
                        <Delta2Kit id={solutionInfo[1]['id']} />
                        {locale !== 'au' && <AppKit id={''} />}
                        <DeltaProKit id={solutionInfo[2]['id']} />
                        {locale === 'au' && <G1 />}
                        {locale === 'au' && <Subscribe />}
                        {locale === 'au' && <AppKit id={''} />}
                        <BuyKit id={''} />
                    </>
                )}
                {/* 占位符-执行离开动画 */}
                <div id="leave-placeholder"></div>
            </div>
        </div>
    );
};

export default SolutionsDetail;
